// src/store/slices/categoriesSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../actions/configApi'; // Assumindo que você tem um arquivo de API configurado
import { getCache, setCache } from '../../../src/util';
// Thunk assíncrono para buscar categorias
export const fetchCategories = createAsyncThunk(
    'categories/fetchCategories',
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get('categoryAll');
            return response.data; // Retorna os atributos que você deseja armazenar
        } catch (error) {
            return rejectWithValue(error.response.data); // Lida com o erro
        }
    }
);

/*export const fetchCategories2 = createAsyncThunk(
    'categories/fetchCategories2',
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get('categoryAll2');
            return response.data; // Retorna os atributos que você deseja armazenar
        } catch (error) {
            return rejectWithValue(error.response.data); // Lida com o erro
        }
    }
);*/
export const fetchCategories2 = createAsyncThunk(
    'categories/fetchCategories2',
    async (_, { dispatch, rejectWithValue }) => {
        const endpoint = 'categoryAll2';
        const params = {}; // sem query, mas mantemos a assinatura

        // 1) Hidrata já se houver cache (UX rápida)
        const cached =  await getCache(endpoint, params);
        if (cached?.data) {
            dispatch({
                type: 'categories/hydrateFromCache', // veja reducer abaixo
                payload: cached.data,
            });
        }

        try {
            // 2) Revalida com ETag, se existir
            const headers = {};
            if (cached?.etag) headers['If-None-Match'] = cached.etag;

            const resp = await api.get(endpoint, { headers });

            // 3) 304 → mantém cache
            if (resp.status === 304 && cached?.data) {
                return cached.data;
            }

            // 4) 200 → atualiza cache e retorna
            const etag = resp.headers?.etag || resp.headers?.ETag || null;
            setCache(endpoint, params, resp.data, { etag, ttl: 5 * 60_000 }); // TTL 5min

            return resp.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data || { message: 'Falha ao buscar categorias' });
        }
    }
);

export const deleteCategory = createAsyncThunk(
    'categories/deleteCategory',
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.delete(`atributoDelete/${id}`);
            return response.data; // Retorna o id para removê-lo do estado
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const deleteCategory2 = createAsyncThunk(
    'categories/deleteCategory2',
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.delete(`atributoDelete-2/${id}`);
            return response.data; // Retorna o id para removê-lo do estado
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const createAttributeValue = createAsyncThunk(
    'categories/createAttributeValue',
    async ({ caracteristica, valores, ordem, selectedClassification }, { rejectWithValue }) => {
        try {
            const response = await api.post('/atributeValues', {
                caracteristica,
                valores,
                ordem,
                selectedClassification
            });
            return response.data; // Retorna os dados do backend, incluindo a mensagem de sucesso e os atributos atualizados
        } catch (error) {
            // Retorna uma mensagem de erro personalizada
            return rejectWithValue(error.response.data.message || 'Erro ao criar atributo');
        }
    }
);
export const createAttributeValue2 = createAsyncThunk(
    'categories/createAttributeValue2',
    async ({ caracteristica, valores, ordem, selectedClassification, selectedTipo }, { rejectWithValue }) => {
        try {
            const response = await api.post('/atributeValues-2', {
                caracteristica,
                valores,
                ordem,
                selectedClassification,
                selectedTipo
            });
            return response.data; // Retorna os dados do backend, incluindo a mensagem de sucesso e os atributos atualizados
        } catch (error) {
            // Retorna uma mensagem de erro personalizada
            return rejectWithValue(error.response.data.message || 'Erro ao criar atributo');
        }
    }
);

export const editAttribute = createAsyncThunk(
    'attributes/editAttribute',
    async ({ id, caracteristica, valores, ordem, selectedClassificationEdit }, { rejectWithValue }) => {
        try {
            const response = await api.put(`atribute/${id}`, {
                caracteristica,
                valores,
                ordem,
                selectedClassificationEdit,
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const editAttribute2 = createAsyncThunk(
    'attributes/editAttribute2',
    async ({ id, caracteristica, valores, ordem, selectedClassificationEdit, selectedTipoEdit }, { rejectWithValue }) => {
        try {
            const response = await api.put(`atribute-2/${id}`, {
                caracteristica,
                valores,
                ordem,
                selectedClassificationEdit,
                selectedTipoEdit
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

const categoriesSlice = createSlice({
    name: 'categories',
    initialState: {
        valores: [],
        valores2: [],
        brandApi: [],
        typesApi: [],
        modelos: [],
        typesApi2: [],
        loading: false,
        error: null,
        successMessage: null,
    },
    reducers: {
        clearSuccessMessage(state) {
            state.successMessage = ''; // Limpa a mensagem de sucesso
        },
        hydrateFromCache: (state, action) => {
            state.typesApi2 = action.payload?.types; // dados do cache
            state.loading = false;            // já temos dados, desliga spinner
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCategories.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCategories.fulfilled, (state, action) => {
                state.loading = false;
                state.valores = action.payload.attributes;
                state.brandApi = action.payload.brands
                state.typesApi = action.payload.types
            })
            .addCase(fetchCategories.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Erro ao carregar categorias';
            })
            .addCase(fetchCategories2.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCategories2.fulfilled, (state, action) => {
                state.loading = false;
                state.valores2 = action.payload.attributes;
                state.modelos = action.payload.modelos;
                state.brandApi = action.payload.brands
                state.typesApi2 = action.payload.types
            })
            .addCase(fetchCategories2.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Erro ao carregar categorias';
            })
            //delete  
            .addCase(deleteCategory.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.successMessage = null;
            })
            .addCase(deleteCategory.fulfilled, (state, action) => {
                state.loading = false;
                // Atualiza todo o estado com a lista de atributos recebida do backend
                state.valores = action.payload.attribute;
                state.successMessage = action.payload.message;
            })
            .addCase(deleteCategory.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Erro ao excluir o atributo';
            })
            //cadastro
            .addCase(createAttributeValue.pending, (state) => {
                state.loading = true;
                state.errorMessage = '';
            })
            .addCase(createAttributeValue.fulfilled, (state, action) => {
                state.loading = false;
                console.log(action.payload, 'ction.payload')
                // Atualiza os atributos com a lista retornada do backend
                state.valores = action.payload.attribute;
                state.successMessage = action.payload.message;
            })
            .addCase(createAttributeValue.rejected, (state, action) => {
                state.loading = false;
                state.errorMessage = action.payload;
            })
            //edicao
            .addCase(editAttribute.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.successMessage = '';
            })
            .addCase(editAttribute.fulfilled, (state, action) => {
                state.loading = false;
                state.valores = action.payload.attribute;
                state.successMessage = action.payload.message;
            })
            .addCase(editAttribute.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            //create-comeerrce
            .addCase(createAttributeValue2.pending, (state) => {
                state.loading = true;
                state.errorMessage = '';
            })
            .addCase(createAttributeValue2.fulfilled, (state, action) => {
                state.loading = false;
                console.log(action.payload, 'ction.payload')
                // Atualiza os atributos com a lista retornada do backend
                state.valores2 = action.payload.attribute;
                state.successMessage = action.payload.message;
            })
            .addCase(createAttributeValue2.rejected, (state, action) => {
                state.loading = false;
                state.errorMessage = action.payload;
            })
            //edit-ecomerce
            .addCase(editAttribute2.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.successMessage = '';
            })
            .addCase(editAttribute2.fulfilled, (state, action) => {
                state.loading = false;
                state.valores2 = action.payload.attributes;
                state.successMessage = action.payload.message;
            })
            .addCase(editAttribute2.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            //delete ecommerce
            .addCase(deleteCategory2.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.successMessage = null;
            })
            .addCase(deleteCategory2.fulfilled, (state, action) => {
                state.loading = false;
                // Atualiza todo o estado com a lista de atributos recebida do backend
                state.valores2 = action.payload.attribute;
                state.successMessage = action.payload.message;
            })
            .addCase(deleteCategory2.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Erro ao excluir o atributo';
            });

    },
});
export const { clearSuccessMessage } = categoriesSlice.actions;
export default categoriesSlice.reducer;
